import MaterialService from "@/services/MaterialService";
import ProfessorService from "@/services/ProfessorService";
import OrganitzacioService from "@/services/OrganitzacioService";
import AssignaturaService from "@/services/AssignaturaService";
import TitulacioService from "@/services/TitulacioService";

const buildFilterQuery = (query, filters) => {

    let fullQuery = query;
    if (filters) {
        const filterQuery = Object.keys(filters)
            .map(key => {
                const values = filters[key].split(',');
                return values.map(value => `AND ${key}:"${value}"`).join(' ');
            })
            .join(' ');
        fullQuery += ' ' + filterQuery.trim();
    }

    return fullQuery
};

export const getMaterials = async (page, size, query, sort, filters) => {
    const fullQuery = buildFilterQuery(query, filters)
    return await MaterialService.getMaterials((page-1)*size, size, fullQuery, sort);
};

export const getProfessors = async (page, size, query, sort, filters) => {
    const fullQuery = buildFilterQuery(query, filters)
    return await ProfessorService.getProfessors((page-1)*size, size, fullQuery, sort);
};

export const getOrganitzacions = async (page, size, query, sort, filters) => {
    const fullQuery = buildFilterQuery(query, filters)
    return await OrganitzacioService.getOrganitzacions((page-1)*size, size, fullQuery, sort);
};

export const getAssignatures = async (page, size, query, sort, filters) => {
    const fullQuery = buildFilterQuery(query, filters)
    return await AssignaturaService.getAssignatures((page-1)*size, size, fullQuery, sort);
};

export const getTitulacions = async (page, size, query, sort, filters) => {
    const fullQuery = buildFilterQuery(query, filters)
    return await TitulacioService.getTitulacions((page-1)*size, size, fullQuery, sort);
};

export const getProfessorsParticipantsOrganitzacio = async (subtipus, id) => {
    if(subtipus === 'centre' || subtipus === 'servei'){
        return await ProfessorService.getProfessorsParticipantsOrganitzacio(`professor_centre_docent:${id}`)
    }else if(subtipus === 'departament'){
        return await ProfessorService.getProfessorsParticipantsOrganitzacio(`professor_departament:${id}`)
    }else if(subtipus === 'institut'){
        return await ProfessorService.getProfessorsParticipantsOrganitzacio(`professor_institut:${id}`)
    }else{ //grup de recerca
        return await ProfessorService.getProfessorsParticipantsOrganitzacio(`professor_grups:${id}`)
    }
};

export const getProfessorsParticipantsAssignatura = async (id) => {
    return await ProfessorService.getProfessorsParticipantsAssignatura(id)
};

export const getProfessorsParticipantsTitulacio = async (id) => {
    return await ProfessorService.getProfessorsParticipantsTitulacio(id)
};

export const createHandleCurrentChange = (name, router, route) => {
    return (currentPage) => {
        router.push({
            name: name,
            params: { page: currentPage, sort: route.params.sort },
            query: { ...route.query } // Mantener los parámetros actuales de la URL
        });
    };
};


export const createHandleOrderChange = (name, router, route, currentPage) => {
    return (selectedOrder) => {
        router.push({
            name: name,
            params: { page: currentPage.value, sort: selectedOrder },
            query: { ...route.query },
        });
    };
};



/**
 * Maneja la aplicación de filtros a la consulta y actualiza los datos.
 *
 * @param {object} params - Parámetros necesarios para manejar el filtro.
 * @param {function} callFunction - Nombre de la función a ejecutar.
 * @param {ref} currentPage - Referencia a la página actual.
 * @param {ref} query - Referencia a la consulta.
 * @param {string} initQuery - Valor de la query inicial
 * @param {ref} response - Referencia para almacenar la respuesta de materiales.
 * @param {ref} totalElements - Referencia para almacenar el total de elementos.
 * @param {object} route - Objeto de ruta.
 * @param {object} store - Objeto de store Vuex.
 */
export const createHandleApplyFilter = async ({ newQuery, callFunction, currentPage, query, initQuery, response, totalElements, route, store }) => {
    //if when I remove all filters
    if (JSON.stringify(newQuery.query) === "{}") {
        //alert("query: " + query.value + " / initQuery: " + initQuery)
        query.value = initQuery;
        const result = await callFunction(currentPage.value, store.getters.pageSize, query.value, route.params.sort);
        response.value = result;
        totalElements.value = result.total;
        return;
    }

    // Modificar solo el campo material_professors_faceta
    /*if (newQuery.query && newQuery.query.material_professors_faceta) {
        newQuery.query.material_professors_faceta = Number(newQuery.query.material_professors_faceta);
        alert(JSON.stringify(newQuery.query))
    }*/

    const result_query = Object.keys(newQuery.query)
        .map(key => {
            const values = newQuery.query[key].split(',');
            return values.map(value => `AND ${key}:"${value}"`).join(' ');
        })
        .join(' ');

    query.value = initQuery + " " + result_query.trim();

    const result = await callFunction(currentPage.value, store.getters.pageSize, query.value, route.params.sort);
    response.value = result;
    totalElements.value = result.total;
};

export const getTipusAssignatura = (tipus, index) => {
    let tipusStr = tipus+""
    return tipusStr.split(",")[index];
}
